var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCooling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1067.9811,
    height: 1215.9224,
    viewBox: "0 0 1067.9811 1215.9224",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg3598",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Draft-1",
    transform: "matrix(0.829192,0,0,1.09268,-325.59511,-1618.3061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3595"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3459"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 809.92,883.19 V 609.076 l -155.246,-81.057 47.246,-84.374 108,56.388 V 387.781 h 99.334 v 112.252 l 107.996,-56.388 47.79,29.571 -0.54,54.803 -30.69,-54.803 30.69,54.803 -155.246,81.057 V 883.19 l 237.386,-137.057 -7.42,-174.976 96.69,-1.27 5.17,121.725 97.21,-56.126 47.81,29.75 1.86,56.276 -97.21,56.126 102.83,65.336 -49.45,83.104 -147.82,-93.919 -237.389,137.057 237.389,137.054 147.82,-93.92 49.45,83.11 -102.83,65.33 97.21,56.13 -49.67,86.03 -97.21,-56.13 -5.17,121.73 -49.5,26.59 -47.19,-27.87 7.42,-174.97 -237.386,-137.06 v 274.12 l 155.246,81.05 -47.25,84.38 -107.996,-56.39 v 112.25 l -49.667,26.53 -49.667,-26.53 V 1438.4 l -108,56.39 -47.246,-84.38 155.246,-81.05 v -274.12 l -237.39,137.06 7.427,174.97 -96.694,1.28 -5.166,-121.73 -97.213,56.13 -49.667,-86.03 97.213,-56.13 -102.834,-65.33 49.447,-83.11 147.82,93.92 237.39,-137.054 -237.39,-137.057 -147.82,93.919 -49.447,-83.104 102.834,-65.336 -97.213,-56.126 49.667,-86.026 97.213,56.126 5.166,-121.725 49.503,-26.6 47.191,27.87 -7.427,174.976 z m -155.787,582.03 47.787,29.57 -47.246,-84.38 z m 410.907,0 -47.79,29.57 47.25,-84.38 z m -532.274,-70.08 -49.503,-26.59 96.694,-1.28 z m -199.688,-121.94 -1.861,-56.28 49.667,86.03 z m 1053.022,0 -47.81,29.75 49.67,-86.03 z m -1058.789,-233.91 -1.715,56.17 49.447,-83.11 z m 1064.549,0 1.72,56.17 -49.45,-83.11 z m 0,-140.145 1.72,-56.171 -49.45,83.104 z m -1064.549,0 -1.715,-56.171 49.447,83.104 z m 5.767,-233.909 47.806,-29.75 -49.667,86.026 z m 853.332,-121.949 49.5,26.6 -96.69,1.27 z m -532.277,-70.071 47.787,-29.571 -47.246,84.374 z m 205.454,-111.961 49.667,26.526 H 809.92 Z",
    style: {
      fill: "#2f2f2f"
    },
    id: "path3457"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3593"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3463"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 586.128,1178.85 -24.761,8.74 8.739,167.99 -18.935,18.45",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3461"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3467"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1145.3,574.459 41.99,-27.901 45.53,27.607 c 0,0 -26.7,-16.153 -40.3,-1.469 -13.59,14.685 -10.51,16.447 -10.51,16.447 l 17.03,152.72 c 0,0 -9.4,25.845 -47.28,1.175 -2.64,-10.573 -6.46,-168.579 -6.46,-168.579 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3465"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3471"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 859.587,370.426 37.149,17.355 c 0,0 -40.697,7.384 -37.149,5.537 3.548,-1.846 15.958,3.696 7.979,-5.537 -7.979,-9.232 -23.262,0 -23.262,0 l 5.462,19.097 -6.939,104.596 -26.954,-11.447 V 392.211 Z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3469"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 904.137,391.954 0.755,106.856 -21.145,30.032 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3473"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3479"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 665.057,478.527 15.231,16.154 16.154,-13.385 146.771,71.54 2.769,-35.078 -141.694,-66.462 -39.231,27.231",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3483"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 815.873,613.064 c 0,0 31.693,-16.57 40.431,-50.807 8.739,-34.238 0,375.832 0,375.832 l -32.517,-57.502 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3481"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3487"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 909.254,502.066 -42.994,50.77 152.25,-67.004 39.32,-8.58 -38.32,-25.956 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3485"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3491"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 496.7,569.098 c 0,0 32.522,-20.361 30.542,-11.594 -1.979,8.766 -3.498,15.494 -3.498,15.494 L 513.045,713.27 488.879,690.485 Z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3489"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 370.005,915.782 -36.682,-19.628 -1.608,-46.334 56.309,22.202 c 0,0 -18.019,-5.792 -21.237,14.479 -3.217,20.271 -1.608,24.776 3.218,29.281 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3493"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3499"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 433.854,782.217 c 0,0 68.643,12.871 100.463,-3.575 31.819,-16.446 -159.097,60.421 -142.651,88.307 -21.451,-23.954 -76.262,-13.586 -54.462,-21.808 21.799,-8.223 96.65,-62.924 96.65,-62.924 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3497"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3503"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 380.508,642.956 0.295,40.358 -43.599,29.956 v -44.096 c 0,0 46.545,-35.645 35.645,-21.505 -10.9,14.14 -37.118,42.715 -25.04,40.653 12.078,-2.062 32.699,-45.366 32.699,-45.366 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3501"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3507"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 388.024,648.988 c 0,0 16.283,29.89 8.142,38.375 -8.142,8.486 443.713,265.733 443.713,265.733 0,0 4.394,-33.682 -35.633,-64.434 C 764.219,857.91 570.43,749.056 570.43,749.056 c 0,0 -33.35,13.179 -47.838,-7.81 -14.488,-20.99 -33.713,-36.122 -33.713,-36.122 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3505"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 332.173,1087.02 c 1.837,-14.57 28.508,-35.73 40.253,-18.11 57.999,15.1 103.512,46.54 147.91,79.43 105.015,-72.49 214.072,-129.62 324.292,-182.33 -41.13,21.037 -74.967,24.962 -85.939,9.601 L 540.31,1116.62 c -24.279,12.12 -88.481,-27.4 -160.598,-92.24 l -39.988,19.32 c 0,0 -8.77,52.99 -7.551,43.32 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3509"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3515"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 538.01,1161.54 c 0,0 -19.966,14.14 -99.418,2.49 -79.451,54.08 -96.922,53.4 -95.674,56.86 1.248,3.46 -4.16,47.97 -4.16,47.97 l 39.102,26.21 6.655,-49.5 c 0,0 -22.462,-52.42 153.495,-84.03 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3513"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3519"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 481.379,1245.61 c 0,0 53.841,-8.86 59.975,-43.28 6.133,-34.42 -29.988,153.69 -8.52,164.59 21.469,10.91 14.313,14.31 14.313,14.31 l -13.631,7.84 -43.278,-22.15 -8.859,-121.31",
    style: {
      fill: "#ffffff"
    },
    id: "path3517"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3523"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 570.093,1176.71 844.628,1016.05 647.152,1144.73 Z",
    style: {
      fill: "#ffffff"
    },
    id: "path3521"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3527"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 859.587,1005.84 c -10.23,21.98 -20.804,77.75 -45.292,51.75 -2.079,24.56 12.008,273.55 -0.211,266.93 l 21.879,15.33 -26.043,-2.07 c 10.013,5.35 25.418,13.25 -149.206,77.54 l -1.034,51.7 c 6.495,-29.48 19.202,-41.87 42.24,-25.85 37.249,-24.6 61.346,-43.73 135.594,-83.75 l 11.373,-12.4 c 0,0 -23.419,-201.72 10.7,-339.18 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3525"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3531"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 909.254,892.36 c 0,0 10.203,49.044 -29.377,67.544 -39.579,18.499 329.233,-199.197 329.233,-199.197 0,0 -53.43,10.176 -56.44,-11.335 -62.38,44.312 -243.416,142.988 -243.416,142.988 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3529"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3535"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1384,667.923 c 0,0 -45.08,-17.47 -31.53,0 11.16,14.403 -34.68,16.346 -129.59,89.923 0,0 54.24,-44.838 22.95,-62.577 42.62,-17.984 93.33,-53.215 93.33,-53.215 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3533"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3539"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1287.1,779.577 c 8.4,2.626 -19.89,23.654 -72.32,25.263 61.93,-2.418 148.08,19.265 114.79,39.91 l 35.74,21.023 26.07,-19.762 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3537"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 950.379,977.409 c 0,0 -30.304,11.914 -65.958,2.804 -35.655,-9.111 296.509,159.077 296.509,159.077 h 33.85 l 143.45,-86.2 23.13,4.91 6.6,-11.91 -40.24,-25.93 -147.16,94.42 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3541"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3547"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1190.63,1166.49 c 0,0 78.23,15.89 95.34,2.06 31.46,18.96 96.87,52.79 96.87,52.79 l -0.51,47.67 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3545"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3551"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 902.077,1312.71 -1.791,19.71 -18.543,20.6 120.657,72.56 36.28,13.44 7.17,19.7 11.65,-2.69 1.79,-38.96 -146.016,-78.38 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3549"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3555"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 816.542,1440.95 43.045,-29.35 v 127.19 l 44.198,7.34 -44.198,25.28 -45.083,-24.06 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3553"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3559"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1158.14,1200.99 -7.23,163.09 28.38,21.64 4.46,-22.19 -12.25,-12.81 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 1
    },
    id: "path3557"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3563"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1150.91,1176.2 -251.454,-141.71 4.329,291.69",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3561"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3567"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1059.29,491.312 v 29.136 l -159.834,85.167 v 286.131 c 0,0 11.601,50.801 -22.765,67.237",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3565"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3571"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 530.493,555.873 42.106,20.074 -5.876,164.997 c 0,0 -9.792,14.688 -44.064,-7.344",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 373.691,913.931 140.762,-89.965 8.206,-1.836 242.716,136.853 6.12,14.313 c 0,0 34.885,12.99 65.485,-14.313",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3573"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3579"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1378.95,671.237 3.35,43.645 c 0,0 -72.74,41.406 -102.21,56.7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3577"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1228.24,579.471 6.34,118.997 c 0,0 17.91,21.43 -6.34,47.272",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3581"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3587"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1372.33,1272.05 -33.49,20.71 -104.24,-56.64 -6.36,124.55 -34.96,18.88",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3585"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3591"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1054.53,1467.02 -35.8,15.54 -115.342,-57.95 -2.841,111.36 -13.352,2.85",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3589"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooling);
export default __webpack_public_path__ + "static/media/cooling.9f7e94899e10192f84d476b5c806d804.svg";
export { ForwardRef as ReactComponent };